import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-071cbac9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "faq-search-result" }
const _hoisted_2 = { class: "row flex-md-row-reverse gx-5" }
const _hoisted_3 = { class: "col-12 col-md-8 col-lg-9" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = {
  key: 1,
  class: "reset-ul list-articles"
}
const _hoisted_6 = { class: "col-12 col-md-4 col-lg-3" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "reset-ul list" }

import { watch } from 'vue';
  import { faqSectionsStore, FaqSectionArticlesStore } from '@/stores';
  import { useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import CardArticle from './components/card-article.vue';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const route = useRoute();
  const store = FaqSectionArticlesStore.create<FaqSectionArticlesStore>({ keyword: route.query.keyword, id: route.query.sectionId || undefined });

  function handlePageChange(page: number) {
    store.fetchData({ page });
  }

  store.fetchData();

  watch(
    () => [route.query.keyword, route.query.sectionId],
    () => {
      store.keyword = String(route.query.keyword);
      store.id = Number(route.query.sectionId) || undefined;
      store.fetchData();
    }
  );


return (_ctx: any,_cache: any) => {
  const _component_AppBreadcurmb = _resolveComponent("AppBreadcurmb")!
  const _component_AppEmptyView = _resolveComponent("AppEmptyView")!
  const _component_AppPagination = _resolveComponent("AppPagination")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBreadcurmb, {
      class: "breadcurmb",
      routes: [{ name: 'Home', to: {name: 'home'} }, { name: 'Search Result' }]
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_unref(t)('result_count', { count: _unref(store).meta.total, keyword: _unref(route).query.keyword })), 1),
        (_unref(store).isEmpty)
          ? (_openBlock(), _createBlock(_component_AppEmptyView, { key: 0 }))
          : (_openBlock(), _createElementBlock("ul", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).data, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id
                }, [
                  _createVNode(CardArticle, {
                    article: item,
                    "show-meta": ""
                  }, null, 8, ["article"])
                ]))
              }), 128))
            ])),
        (_unref(store).meta.total_pages > 1)
          ? (_openBlock(), _createBlock(_component_AppPagination, {
              key: 2,
              total: _unref(store).meta.total,
              "per-page": _unref(store).meta.per_page,
              page: _unref(store).meta.page,
              onChange: handlePageChange
            }, null, 8, ["total", "per-page", "page"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h3", _hoisted_7, _toDisplayString(_unref(t)('by_category')), 1),
        _createElementVNode("ul", _hoisted_8, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              class: _normalizeClass({ active: !_unref(route).query.sectionId }),
              to: { query: { keyword: _unref(route).query.keyword } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('all_categories')), 1)
              ]),
              _: 1
            }, 8, ["class", "to"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(faqSectionsStore).data, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.id
            }, [
              _createVNode(_component_router_link, {
                class: _normalizeClass({ active: String(item.id) === String(_unref(route).query.sectionId) }),
                to: { query: { sectionId: item.id, keyword: _unref(route).query.keyword } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.title), 1)
                ]),
                _: 2
              }, 1032, ["class", "to"])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})